import React from 'react';
import { Navigate } from 'react-router-dom';

// M6 fix: Auth guard component to protect routes that require authentication
const ProtectedRoute = ({ children }) => {
    const token = localStorage.getItem('token');
    if (!token) {
        return <Navigate to="/login" replace />;
    }
    return children;
};

export default ProtectedRoute;
